import { FC } from 'react';
import { container } from 'system/registry';
import { LoadingProvider } from 'application/contexts/useLoading';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { buyerUserContext, useBuyerUser } from 'application/contexts/useBuyerUser';
import { buyerChatContext, useBuyerChat } from 'application/contexts/useBuyerChatRoom';
import { buyerSupportChatContext, useBuyerSupportChat } from 'application/contexts/useBuyerSupportChat';
import { ScrollToTop } from 'ui/components/layouts/ScrollToTop';
import { Outlet } from 'react-router-dom';

const BuyerContextConfig: FC = () => {
    return (
        <LoadingProvider>
            <ScrollToTop />
            <BuyerContexts />
        </LoadingProvider>
    );
};

const BuyerContexts: FC = () => {
    const buyerUserCtx = useBuyerUser();
    const buyerChatCtx = useBuyerChat();
    const buyerSupportChatCtx = useBuyerSupportChat();
    return (
        <diContainerContext.Provider value={container}>
            <buyerUserContext.Provider value={buyerUserCtx}>
                <buyerChatContext.Provider value={buyerChatCtx}>
                    <buyerSupportChatContext.Provider value={buyerSupportChatCtx}>
                        <Outlet />
                    </buyerSupportChatContext.Provider>
                </buyerChatContext.Provider>
            </buyerUserContext.Provider>
        </diContainerContext.Provider>
    );
};

export default BuyerContextConfig;
